import React, { useState } from "react";
import DashboardLayout from "../../../layout/dashboard/DashboardLayout";
import TitleTextBox from "../../../fragments/TitleTextBox";
import ContainerWrapper from "../../../fragments/ContainerWrapper";
import "../../../styles/dashboard/settings/settingsIndex.css";
import Icons from "../../../assets/icons/icons";
import {
  RavenButton,
  RavenCheckBox,
  RavenInputField,
} from "@ravenpay/raven-bank-ui";
import cacImage from "../../../assets/Frame 2147223890.png";
import pdfImage from "../../../assets/FE27A792-8B7F-4B48-BA15-CA343515A50A 2.png";
import BadgeComponent from "../../../fragments/badge/BadgeComponent";
import { removeSpace } from "../../../utils/helpers";
import { log } from "console";
import PreviewUploadFileModal from "../../../components/PreviewUploadFile";
import { verify } from "crypto";
import { veryfyRcNumber } from "../../../redux/insight";
import { useDispatch } from "react-redux";
import { RouteLinks } from "../../../routes/RouteLinks";
import { useLocation, useNavigate } from "react-router-dom";
interface MyComponentProps {
  children?: React.ReactNode;
}
const SettingsIndex: React.FC<MyComponentProps> = ({ children }) => {
  const linkList = [
    { name: "Business Profile", link: RouteLinks?.Settings_business_profile },
    {
      name: "CAC Verification",
      link: RouteLinks?.Settings_cac_verification,
    },

    {
      name: "Settlement Account",
      link: RouteLinks?.Settings_settlement_account,
    },
  ];

  const navigate = useNavigate();
  const location = useLocation();

  const [sideBarContentActive, setSideBarContentActive] = useState(
    "Business Information"
  );
  const [editMode, seteditMode] = useState(false);
  const [reciept, setReciept] = useState(false);
  const [rcNumberScreen, setRcNumberScreen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [notValidRcNumber, setNotValidRcNumber] = useState(false);
  const [file, setFile] = useState<File | null>();
  const [memartFile, setMemartFile] = useState<File | null>();
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [selectedFieldName, setSelectedFieldName] = useState<string>("");
  const dispatch = useDispatch();
  const [businessDetails, setBusinessDetails] = useState({
    nature_of_business_name: null,
    company_type_name: null,
    classification_id: 0,
    delisting_status: null,
    rc_number: 0,
    email: "",
    address: "",
    city: "",
    lga: "",
    active: false,
    id: 0,
    business_commencement_date: null,
    registration_approved: false,
    head_office_address: "",
    objectives: null,
    classification: null,
    registration_date: "",
    approved_name: "",
    branch_address: "",
    state: "",
  });

  const [currentStep, setCurrentStep] = useState<
    "cacRc" | "rcNumber" | "selectBusiness" | "cacResult"
  >("cacRc");

  const [businessInfo, setBusinessInfo] = useState({
    firstName: "Abigail",
    lastName: "Uye",
    address: "20 The Quad Layi Yusuf Lekki Lagos",
    businessName: "Regius portus",
    emmailAddress: "abby@gmail.com",
    phoneNumber: "09078654433",
    businessIndustry: "Beauty",
    employeeCount: "50-100",
    accountNumber: "2348588865",
    bankName: "Gtb",
  });

  const handleVerifyRcNumber = async (userRcNumber: string) => {
    setRcNumber(userRcNumber);
    const data = await dispatch(
      veryfyRcNumber({ rcNumber: userRcNumber }) as any
    );

    if (data?.status === "success") {
      //   handleFinish();
      setBusinessInfo(data.data.data);
    } else {
      setNotValidRcNumber(true);
    }
  };

  

  

  const [rcNumber, setRcNumber] = useState("");

  const handleDisable = () => {
    return !rcNumber;
  };


  //   const handleFileChange = (event: File) => {
  //     setFile(event);
  //   };
  const handleMemartFileChange = (event: File) => {
    setMemartFile(event);
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      setSelectedFile(file);
      setIsModalOpen(true); // open modal after selecting file
    }
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const loading = false;

  return (
    <>
      <DashboardLayout>
        <TitleTextBox
          title="Settings"
          text="Manage Bankbox devices on the platform"
        ></TitleTextBox>
        <ContainerWrapper dontShowHeader width={`100%`}>
          <div className="settings-general-wrap-container-box">
            <div className="settings-general-wrap-container-box-inner">
              <div className="settings-side-bar-wrap grey-bg">
                {linkList.map((item, index) => {
                  const { name, link } = item || {};
                  return (
                    <p
                      className={`settings-side-bar-content-box  ${
                        location?.pathname?.includes(link) && "active white-black-bg"
                       
                      }`}
                      onClick={() => {
                        if (location?.pathname !== link) {
                          navigate(link);
                        }
                        setSideBarContentActive(name);
                      }}
                    >
                      {item.name}
                    </p>
                  );
                })}
              </div>

              <div className="settings-right-side-wrap-cont">{children}</div>
            </div>
            {/* <PreviewUploadFileModal
            businessName="Mauritous Nigeria Limited"
            visible
            btnLabel="."
            onClose={closeModal}
            /> */}
          </div>
        </ContainerWrapper>
      </DashboardLayout>
    </>
  );
};

export default SettingsIndex;
